import React from 'react';
import PlaceholderPage from '../components/common/PlaceholderPage';

const securitymanagementPage: React.FC = () => {
  return (
    <PlaceholderPage
      title="Security Management"
      description="Security policies and compliance"
      features={["Security Policies","Compliance Monitoring","Security Audits","Incident Response"]}
      comingSoon={true}
    />
  );
};

export default securitymanagementPage;
